import {FlexRow, Modal, Text} from '@forecast-it/design-system';
import React from 'react';
import {useIntl} from 'react-intl';
import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {ModalProps} from '../../../../forecast-app/shared/components/modals/types';

export type DiscardQuoteModalPayload = {
	onDiscard: () => void;
};

export const showDiscardQuoteModal = (props: DiscardQuoteModalPayload): void => {
	showModal({
		type: MODAL_TYPE.DISCARD_QUOTE,
		...props,
	});
};

/**
 * Cancelling mid-creation loses the whole configuration — nothing is persisted until the quote is
 * created — so it asks first. Dismissing returns to the designer with nothing changed.
 */
export const DiscardQuoteModal = ({closeModal, onDiscard}: ModalProps<DiscardQuoteModalPayload>): JSX.Element => {
	const intl = useIntl();

	const handleDiscard = () => {
		onDiscard();
		closeModal();
	};

	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal} closeOnInteractOutside={false}>
			<Modal.Title>{intl.formatMessage({id: 'quote_designer.discard_modal.title'})}</Modal.Title>
			<Modal.Content>
				<Text>{intl.formatMessage({id: 'quote_designer.discard_modal.body'})}</Text>
				<FlexRow>
					<Modal.PrimaryFooterButton onPress={handleDiscard} dataCy="discard-quote-confirm">
						{intl.formatMessage({id: 'quote_designer.discard_modal.confirm'})}
					</Modal.PrimaryFooterButton>
					<Modal.SecondaryFooterButton onPress={closeModal} dataCy="keep-editing">
						{intl.formatMessage({id: 'quote_designer.discard_modal.cancel'})}
					</Modal.SecondaryFooterButton>
				</FlexRow>
			</Modal.Content>
		</Modal>
	);
};
